import { z } from 'zod';
import { ACCOUNT_NUMBER_PATTERN, ROUTING_NUMBER_PATTERN } from '../constants';
import { validateRoutingNumberInput } from '../utils';
export const addBankAccountFormSchema = z
    .object({
    accountType: z.enum(['checking', 'savings']),
    accountName: z.string().min(1, { message: 'Required' }),
    routingNumber: z
        .string()
        .min(1, { message: 'Required' })
        .regex(ROUTING_NUMBER_PATTERN, {
        message: 'Enter a valid 9-digit routing number.',
    })
        .refine((value) => !validateRoutingNumberInput(value), {
        message: 'Enter a valid routing number.',
    }),
    accountNumber: z
        .string()
        .min(1, { message: 'Required' })
        .regex(ACCOUNT_NUMBER_PATTERN, {
        message: 'Enter your account number, 4 to 17 digits.',
    }),
    accountNumberConfirmation: z.string().min(1, { message: 'Required' }),
})
    .superRefine((data, ctx) => {
    if (data.accountNumberConfirmation &&
        data.accountNumber !== data.accountNumberConfirmation) {
        ctx.addIssue({
            code: 'custom',
            message: 'Account numbers do not match.',
            path: ['accountNumberConfirmation'],
        });
    }
});
